import { meta } from './meta';

export const PLAYER_SERVICE_NAME = 'player';
export const RADIO_PLAYER_SERVICE_NAME = 'radioPlayer';
export const API_SCHEMA = {
  [PLAYER_SERVICE_NAME]: true,
  [RADIO_PLAYER_SERVICE_NAME]: meta.alias === 'radio-player'
};
